import { motion, AnimatePresence } from "framer-motion";

import { useLocation } from "react-router-dom";

const Container= (props)=>{
    const location = useLocation();
    return(
        <AnimatePresence mode="wait">
            <motion.div 
                key={location.pathname}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
                className="!w-full"
            >
                {props.children}
            </motion.div>
        </AnimatePresence>
    );
}
export default Container;